import { ActionTypes } from "./types";

const { SET_SPECIAL_UNITS, SET_FILTERS, ADD_SPECIAL_UNIT, UPDATE_SPECIAL_UNIT, REMOVE_SPECIAL_UNIT, RESTORE_INITIAL } = ActionTypes;

const INITIAL_STATE = {
  units: [],
  station: null,
  startDate: "",
  endDate: "",
};

export const specialUnitsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SET_SPECIAL_UNITS:
      return { ...state, units: payload };

    case ADD_SPECIAL_UNIT:
      return { ...state, units: [payload, ...state.units] };

    case UPDATE_SPECIAL_UNIT:
      return {
        ...state,
        units: state.units.map((u) => (u.id === payload.id ? payload : u)),
      };

    case REMOVE_SPECIAL_UNIT:
      return { ...state, units: state.units.filter((u) => u.id !== payload) };

    case SET_FILTERS: {
      let units = state.units;
      if (payload.key === "station") units = [];
      return { ...state, [payload.key]: payload.value, units };
    }

    case RESTORE_INITIAL:
    case "CLOSE_SESSION_LOGIN":
      return INITIAL_STATE;

    default:
      return state;
  }
};
